'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { MediaQueryStylesContext } from './MediaQueryStylesContext';
import MediaQueryStyles from './MediaQueryStyles';

const MediaQueryStylesProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MediaQueryStyles, {}), /*#__PURE__*/_jsx(MediaQueryStylesContext.Provider, {
      value: {
        hasInjectedGlobalStyles: true
      },
      children: children
    })]
  });
};

MediaQueryStylesProvider.propTypes = {
  children: PropTypes.node
};
export default MediaQueryStylesProvider;